module.exports = __webpack_public_path__ + "static/img/1.3abf163.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cs/1.jpg
// module id = P/Aj
// module chunks = 1